export default "__VITE_ASSET__3ZhR7RNN__"